export default "__VITE_ASSET__e8a18444__"